module.exports = __webpack_public_path__ + "static/media/icon.e87ea239.png";